<div class="map-popup-header">
    <div class="map-popup-title">
        <a [routerLink]="['/planera', arbetsorder.id]">{{ arbetsorder.namn }}</a>
    </div>
    <div class="map-popup-beteckning">{{ arbetsorder.beteckning }}</div>
</div>
<div class="arbetsorder-header-table">
    <div class="row mx-0">
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_TALLTIMMER"></div>
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_GRANTIMMER"></div>
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_KLENTIMMER_TALL"></div>
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_KLENTIMMER_GRAN"></div>
        <div class="map-popup-table-header col ps-0 pe-2" translate="PLANERA_ARBETSORDER_HEADER_B-MAV"></div>
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_L-MAV"></div>
    </div>
    <div class="row mx-0">
        <div class="col p-0">{{ arbetsorder.tallTimmer }}</div>
        <div class="col p-0">{{ arbetsorder.granTimmer }}</div>
        <div class="col p-0">{{ arbetsorder.klentimmerTall }}</div>
        <div class="col p-0">{{ arbetsorder.klentimmerGran }}</div>
        <div class="col ps-0 pe-2">{{ arbetsorder.barrmassaved }}</div>
        <div class="col p-0">{{ arbetsorder.lovmassaved }}</div>
    </div>
</div>
<div class="map-popup-split-container">
    <div class="map-split-left">
        <!-- Medelstam -->
        <table>
            <tr>
                <td class="map-popup-table-header" translate="PLANERA_POPUP_MEDELSTAM"></td>
            </tr>
            <tr>
                <td>{{ arbetsorder.medelstam | number: '1.1-2' }}</td>
            </tr>
        </table>
        <!-- Mark/Väg -->
        <table>
            <tr>
                <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_TILLGANGLIGHET_SKOG"></td>
                <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_BILVAG"></td>
            </tr>
            <tr>
                <td>{{ arbetsorder.tillganglighetMark }}</td>
                <td>{{ arbetsorder.tillganglighetVag }}</td>
            </tr>
        </table>
        <!-- Avverkningsgrupp -->
        <table>
            <tr>
                <td class="map-popup-table-header" translate="PLANERA_POPUP_AVVERKNINGSGRUPP"></td>
            </tr>
            <tr>
                <td>{{ arbetsorder.avverkningsgruppForkortning }}</td>
            </tr>
        </table>
    </div>
    <div class="map-split-right">
        <!-- Volym -->
        <table>
            <tr>
                <td class="map-popup-table-header" translate="PLANERA_POPUP_VOLYM"></td>
            </tr>
            <tr>
                <td>{{ arbetsorder.volymArbetsorder | number }}</td>
            </tr>
        </table>
        <!-- Datum -->
        <table>
            <tr>
                <td class="map-popup-table-header" translate="PLANERA_POPUP_DATUM"></td>
            </tr>
            <tr>
                <td>{{ getArbetsorderPeriod(arbetsorder) }}</td>
            </tr>
        </table>
        <!-- Tillgänglighet -->
        <table>
            <tr>
                <td class="map-popup-table-header" translate="PLANERA_POPUP_PLANERINGSSTATUS"></td>
            </tr>
            <tr>
                <td>{{ arbetsorder.planeringsstatus?arbetsorder.planeringsstatus:'' }}</td>
            </tr>
        </table>
    </div>
</div>